import { useState } from 'react';

import type { ISorted } from '@feathr/components';

export interface IGoalsTableState {
  sort: ISorted[];
  page: number;
  pageSize: number;
  handleSortChange: (newSort: ISorted[]) => void;
  handlePageChange: (newPage: number) => void;
  handlePageSizeChange: (newPageSize: number, newPage: number) => void;
}

export function useGoalsTableState(
  initialSort: ISorted[] = [{ id: 'name' }],
  initialPageSize: number = 5,
): Readonly<IGoalsTableState> {
  const [sort, setSort] = useState<ISorted[]>(initialSort);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(initialPageSize);

  function handleSortChange(newSort: ISorted[]): void {
    setSort(newSort);
  }

  function handlePageChange(newPage: number): void {
    setPage(newPage);
  }

  function handlePageSizeChange(newPageSize: number, newPage: number): void {
    setPageSize(newPageSize);
    setPage(newPage);
  }

  return {
    sort,
    page,
    pageSize,
    handleSortChange,
    handlePageChange,
    handlePageSizeChange,
  };
}
